module.exports = __webpack_public_path__ + "img/specials-multislider-ford-2025.086a34a1.png";